import React from "react";
import { withTranslation } from "react-i18next";
import './GraphCard.scss';
import { FiBarChart, FiTrendingDown, FiTrendingUp } from "react-icons/fi";

const EmptyGraphDataCard = ({ t, graphConfig = false }) => {
	if (graphConfig) {
		return (
			<div className="no-configs-card">
				<div>
					<h4><FiTrendingUp/></h4>
					<h6 className="mb-4">{t('NoGraphsConfigured.label')}</h6>
				</div>
			</div>

		);
	} else {
		return (
			<p className="text-center">{t('NoDataAvailable.label')}</p>
		);
	}
};

export default withTranslation()(EmptyGraphDataCard);
